import React, { useCallback, useContext, useMemo, useState } from 'react';

import { FormControlLabel, Switch } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import _ from 'lodash';
import { useResizeDetector } from 'react-resize-detector';

import { AuthContext } from '../../_context/AuthContext';
import GrowthStagesLegend from '../Growths/GrowthStagesLegend';
import GrowthTimelineSelector from '../Growths/GrowthTimeline/GrowthTimelineSelector';

import ActivitiesTimelineChart from './ActivitiesTimelineChart';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%'
  },
  timelineContainer: {
    position: 'relative',
    width: '100%'
  },
  counceModelSwitchContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end'
  }
}));

const ActivitiesTimeline = ({
  inProgress,
  timelineActivities,
  minDate,
  maxDate,
  showModifiedDate,
  disableFarmName
}) => {
  const styles = useStyles();

  const { width, ref: containerRef } = useResizeDetector();

  const { isAdmin } = useContext(AuthContext);

  const [showVStages, setShowVStages] = useState(false);

  const [rangeSelection, setRangeSelection] = useState();
  const handleRangeSelected = useMemo(
    () => _.debounce(setRangeSelection, 10),
    []
  );

  const hasGrowths = _.get(timelineActivities, 'length', 0) > 0;

  const handleToggleVStages = useCallback(() => {
    setShowVStages((show) => !show);
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.timelineContainer} ref={containerRef}>
        {!inProgress && hasGrowths && !_.isNaN(width) && _.isNumber(width) && (
          <>
            {isAdmin && (
              <Box className={styles.counceModelSwitchContainer}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={showVStages}
                      onChange={handleToggleVStages}
                      name="checkedB"
                      color="primary"
                    />
                  }
                  label="Show Counce Growth Model Stages (V and R)"
                />
              </Box>
            )}
            <ActivitiesTimelineChart
              timelineActivities={timelineActivities}
              containerWidth={width}
              minDate={minDate}
              maxDate={maxDate}
              rangeSelection={rangeSelection}
              showVStages={showVStages}
              showModifiedDate={showModifiedDate}
              disableFarmName={disableFarmName}
            />
            <GrowthTimelineSelector
              timelineGrowths={timelineActivities}
              containerWidth={width}
              minDate={minDate}
              maxDate={maxDate}
              onRangeSelected={handleRangeSelected}
            />
            <GrowthStagesLegend />
          </>
        )}
      </div>
      {!inProgress && !hasGrowths && (
        <Alert severity="info">
          <AlertTitle>No Growths</AlertTitle>
          There are no active growths configured for the selected Grower. In
          order to display the growths timeline, please create a growth.
        </Alert>
      )}
      {inProgress && <CircularProgress />}
    </div>
  );
};

export default ActivitiesTimeline;
